var _rect, _path, _path2, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.875,
    y: 4.41309,
    width: 5.35711,
    height: 9.64279,
    rx: 1,
    fill: "#9AC8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2189 15.0506L18.8398 2.78667C18.4776 2.45468 18.0041 2.27051 17.5128 2.27051C17.0215 2.27051 16.548 2.45468 16.1858 2.78667L2.8081 15.0506C2.64185 15.2034 2.52557 15.4028 2.47445 15.6228C2.42333 15.8427 2.43975 16.073 2.52157 16.2834C2.60339 16.4939 2.74681 16.6748 2.93306 16.8025C3.11932 16.9301 3.33976 16.9986 3.56557 16.999C4.92637 16.999 6.02953 18.1021 6.02953 19.463V29.4651C6.02953 29.8335 6.10209 30.1983 6.24308 30.5387C6.38406 30.879 6.59071 31.1883 6.85122 31.4488C7.11173 31.7093 7.421 31.916 7.76137 32.057C8.10174 32.1979 8.46654 32.2705 8.83496 32.2705H26.1906C26.559 32.2705 26.9238 32.1979 27.2642 32.057C27.6046 31.916 27.9138 31.7093 28.1744 31.4488C28.4349 31.1883 28.6415 30.879 28.7825 30.5387C28.9235 30.1983 28.996 29.8335 28.996 29.4651V19.4644C28.996 18.103 30.1 16.9996 31.4614 17.0004C31.6875 17.0003 31.9083 16.9319 32.0949 16.8042C32.2815 16.6765 32.4251 16.4954 32.507 16.2846C32.5889 16.0738 32.6052 15.8432 32.5538 15.623C32.5024 15.4029 32.3856 15.2033 32.2189 15.0506Z",
    fill: "url(#paint0_linear_646_10926)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.069 14.4928C13.7826 13.8098 14.6397 13.2946 15.5776 12.9849C16.0449 13.6274 16.8029 14.0452 17.6584 14.0452C18.514 14.0452 19.2719 13.6274 19.7392 12.9849C20.6772 13.2946 21.5342 13.8098 22.2479 14.4928C21.9467 15.2089 21.9722 16.0527 22.3906 16.7774C22.7877 17.4651 23.4544 17.9 24.1801 18.0256C24.2609 18.444 24.3015 18.8691 24.3012 19.2952C24.3012 19.8894 24.2232 20.4653 24.0769 21.0133C23.3915 21.161 22.7687 21.5866 22.3906 22.2416C22.2205 22.5353 22.1105 22.8598 22.0668 23.1963C22.0232 23.5328 22.0468 23.8747 22.1362 24.202C21.3685 24.904 20.4464 25.4155 19.4444 25.6951C18.9655 25.2316 18.3249 24.9728 17.6584 24.9737C16.9919 24.9728 16.3513 25.2316 15.8724 25.6951C14.8704 25.4154 13.9484 24.9039 13.1806 24.202C13.2701 23.8747 13.2937 23.5328 13.25 23.1963C13.2064 22.8598 13.0963 22.5353 12.9263 22.2416C12.5481 21.5867 11.9254 21.161 11.2399 21.0133C11.0905 20.4529 11.0151 19.8753 11.0156 19.2952C11.0156 18.8611 11.0573 18.4366 11.1368 18.0256C11.8625 17.9 12.5292 17.4651 12.9263 16.7774C13.3447 16.0527 13.3702 15.2088 13.069 14.4928ZM17.6584 22.5095C19.4337 22.5095 20.8727 21.0705 20.8727 19.2952C20.8727 17.52 19.4337 16.0809 17.6584 16.0809C15.8832 16.0809 14.4442 17.52 14.4442 19.2952C14.4442 21.0705 15.8832 22.5095 17.6584 22.5095ZM17.6584 20.9023C16.7116 20.9023 15.9442 20.1349 15.9442 19.1881C15.9442 18.2413 16.7116 17.4738 17.6584 17.4738C18.6053 17.4738 19.3727 18.2413 19.3727 19.1881C19.3727 20.1349 18.6053 20.9023 17.6584 20.9023Z",
    fill: "url(#paint1_linear_646_10926)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_646_10926",
    x1: 17.5142,
    y1: 2.27051,
    x2: 17.5142,
    y2: 32.2705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_646_10926",
    x1: 17.6584,
    y1: 12.9849,
    x2: 17.6584,
    y2: 25.6951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting1);
export default "https://c.d2cgo.com/dtc_center-setting/v19/assets/static/media/setting1.8206d38b3eb283f91b3aebdab78503ff.svg";
export { ForwardRef as ReactComponent };